export default class PromiseCancelError extends Error {
    // eslint-disable-next-line no-useless-constructor
    constructor(...args) {
        super(...args);
    }
}
